import { IconButton, IIconButtonProps, Tooltip } from '@archer-technologies/ui-components';
import { Plugin, Template, TemplateConnector, TemplatePlaceholder } from '@devexpress/dx-react-core';
import * as React from 'react';
import { HandleClearFilters } from './types';

interface ToolbarClearFiltersPluginProps {
  messages: any;
  disabled?: boolean;
  handleClearFilters: HandleClearFilters;
}

const pluginDependencies = [{ name: 'Toolbar' }, { name: 'FilteringState' }];

export const ToolbarClearFilters = ({ messages, disabled, handleClearFilters }: ToolbarClearFiltersPluginProps) => {
  const toolTipProps = { title: messages.clearFilters };
  const iconButtonProps: IIconButtonProps = {
    icon: 'ClearFilter',
    label: messages.clearFilters,
    disabled
  };

  const createButtonComponent = (onClick: () => void) => (
    <Tooltip {...toolTipProps}>
      <IconButton onClick={onClick} {...iconButtonProps} aria-label={messages && messages.clearFilters ? messages.clearFilters : 'Clear Filters'} />
    </Tooltip>
  );

  return (
    <Plugin name="toolbarClearFilters" dependencies={pluginDependencies}>
      <Template name="toolbarContent">
        <TemplatePlaceholder />
        <TemplateConnector>
          {({ filters }, { changeColumnFilter }) =>
            filters?.length ? createButtonComponent(() => handleClearFilters(filters, changeColumnFilter)) : null
          }
        </TemplateConnector>
      </Template>
    </Plugin>
  );
};
